import { Icon, Timeline, TimelineItem } from '@ps/isp-web-component-library';
import { Ninety } from '@ps/isp-web-component-library/icons/Ninety';
import { StarSubIcon } from '@ps/isp-web-component-library/icons/StarSubIcon';
import { TwoUpIcon } from '@ps/isp-web-component-library/icons/TwoUpIcon';
import type { SgmData } from '@ps/isp-web-services-types';
import { getIsMatchOddsNinetyMarket, getIsTwoUpMarket } from '@ps/web-sports-utils';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import AnimatedInPlayIcon from '@swf/sports/components/AnimatedInPlayIcon/AnimatedInPlayIcon';
import BetDate from '@swf/sports/components/BetDate/BetDate';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import {
  TXTWCL_Match_Odds_90,
  TXTWCL_Match_Odds___2_Up,
  TXTWCL_Star_Sub_enabled_selection
} from './SgmOpportunityDescription.messages.json';
import styles from './SgmOpportunityDescription.scss';

interface Props {
  sgmData: SgmData[];
  hasVisibleDates?: boolean;
  isRestrictedPlayMoneyOpportunity?: boolean;
}

export const SgmOpportunityDescription: React.FC<Props> = ({
  sgmData,
  hasVisibleDates,
  isRestrictedPlayMoneyOpportunity
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <>
      {sgmData.map((sgmDataValue, sgmDataIndex) => (
        <React.Fragment key={sgmDataIndex}>
          <div className={styles.eventNameWrapper}>
            <div className={styles.iconWrapper}>
              <Icon
                icon={getEventTypeIcon(sgmDataValue.eventTypeId)}
                className={styles.icon}
                size="x1"
              />
            </div>
            <div className={styles.eventInfoWrapper}>
              <h4
                className={classNames(styles.eventName, {
                  [styles.restricted]: isRestrictedPlayMoneyOpportunity
                })}
              >
                {sgmDataValue.eventName}
                {sgmDataValue.eventInPlay ? (
                  <AnimatedInPlayIcon className={styles.inPlayIcon} />
                ) : null}
              </h4>
              {hasVisibleDates && (
                <span className={styles.date}>
                  <BetDate eventStartDate={sgmDataValue.eventStartTime} />
                </span>
              )}
            </div>
          </div>

          <div className={styles.timeline}>
            <Timeline>
              {sgmDataValue.descriptions.map((sgmDescription) => (
                <TimelineItem key={`${sgmDescription.marketName} - ${sgmDescription.runnerName}`}>
                  <span
                    className={classNames(styles.description, {
                      [styles.invalid]: !sgmDescription.isValid,
                      [styles.restricted]: isRestrictedPlayMoneyOpportunity
                    })}
                  >
                    <span className={styles.runnerName}>{sgmDescription.runnerName}</span> -{' '}
                    <span className={styles.marketName}>{sgmDescription.marketName}</span>
                    {sgmDescription.isStarSubEnabled && (
                      <Icon
                        icon={StarSubIcon}
                        className={styles.marketIcon}
                        label={formatMessage(TXTWCL_Star_Sub_enabled_selection)}
                        size="xs"
                      />
                    )}
                    {getIsMatchOddsNinetyMarket(sgmDescription.marketType) ? (
                      <Icon
                        icon={Ninety}
                        className={styles.marketIcon}
                        label={formatMessage(TXTWCL_Match_Odds_90)}
                        size="xs"
                      />
                    ) : null}
                    {getIsTwoUpMarket(sgmDescription.marketType) ? (
                      <Icon
                        icon={TwoUpIcon}
                        className={styles.marketIcon}
                        label={formatMessage(TXTWCL_Match_Odds___2_Up)}
                        size="xs"
                      />
                    ) : null}
                  </span>
                </TimelineItem>
              ))}
            </Timeline>
          </div>
        </React.Fragment>
      ))}
    </>
  );
};
